export const LATEST_MODEL = "LATEST_MODEL";

export const getLatestModel = (data) => {
    return {
        type: LATEST_MODEL,
        payload: data
    }
}